// PDFGeneration.js
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ReactDOM from "react-dom/client";

const generatePDF = async (jsxContent) => {
  // Create a hidden container to render the JSX content
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.top = "-10000px";
  container.style.left = "-10000px";
  container.style.zIndex = "-1";
  container.style.background = "#fff";
  document.body.appendChild(container);

  // Render the JSX content using React 18+ root
  const root = ReactDOM.createRoot(container);
  root.render(jsxContent);

  // Wait for rendering and assets (images/fonts)
  await new Promise((resolve) => setTimeout(resolve, 500));

  const element = container.querySelector("#jl-certificate-container");
  if (!element) {
    console.error("Element not found for PDF generation");
    root.unmount();
    document.body.removeChild(container);
    return;
  }

  // Generate canvas from the rendered element
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#fff",
  });

  const imgData = canvas.toDataURL("image/jpeg", 0.9);
  const pdf = new jsPDF("p", "pt", "a4");

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
  pdf.save("certificate.pdf");

  // Clean up
  root.unmount();
  document.body.removeChild(container);
};

export default generatePDF;
